import { useGetAssetModelsQuery } from '../service';

interface UseAssetModelsProps {
  search?: string;
  brandId?: string;
  page?: number;
  pageSize?: number;
}

const useAssetModels = ({
  search,
  brandId,
  page = 1,
  pageSize = 5,
}: UseAssetModelsProps = {}) => {
  const { data, isLoading, error } = useGetAssetModelsQuery({
    search: search || '',
    brandId,
    paginated: {
      page,
      pageSize,
    },
  });

  return {
    assetModels: data?.items || [],
    isLoading,
    error,
  };
};

export default useAssetModels;
